import styled from 'styled-components';
import {mobileMedia, BLACK, SUCCESS_COLOR, BRIGHT_RED, DEFAULT_COLOR, ellipsis} from '../../../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexBetween, dFlexStart} from '../../../../globalVariables/GlobalFlex';

export const leadItem = styled.div`
    height: 65px;
    min-height: fit-content;
    border-radius: 10px;
    border: 0.5px solid ${BLACK};
    position: relative;
    padding: 11px 14px 12px 11px;

    ${mobileMedia} {
        width: 100%;
        padding: 12px;
    }
`;

export const leadHeader = styled.div`
    ${dFlexBetween}
    margin-bottom: 10px;
`;

export const leadName = styled.div`
    color: ${BLACK};
    text-align: start;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    height: 16px;
    ${ellipsis}
    ${mobileMedia} {
        max-width: 250px;
    }
`;

export const statusIndicator = styled.div<{$status: string}>`
    width: 8px;
    height: 8px;
    border-radius: 7px;
    background: ${props => props.$status === 'RUNNING' ? SUCCESS_COLOR : BRIGHT_RED};
    outline: 3px solid ${props => props.$status === 'RUNNING' ? `${SUCCESS_COLOR}33` : `${BRIGHT_RED}33`};
`;

export const leadStats = styled.div`
    ${dFlexStart}
    gap: 10px;
    
    ${mobileMedia} {
        flex-wrap: wrap;
        gap: 8px;
    }
`;

export const statItem = styled.div`
    gap: 4px;
    font-weight: 500; 
    font-size: 12px;
    max-width: 250px;     
    min-width: fit-content;
    position: relative;
    margin-inline-end: 16px;

    &:not(:last-child)::after {
        content: '';
        position: absolute;
        top: calc(50% - 3px);
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-inline-start: 10px;
        background: ${DEFAULT_COLOR};
    }
`;
